import styled from "styled-components";
import {FloatingContainer} from "../../AppStyle";
import {styles} from "../../../config";

const alertWindowDistanceFromEdge = `19`;
const alertBorderRadius = `7px`;

export const AlertScreenOverlayMessageWindow = styled.div`
    ${FloatingContainer};
    background-color: #ffffff;
    position: absolute;
    top: 30%;
    width: calc(100% - ${alertWindowDistanceFromEdge * 2}px);
    left: ${alertWindowDistanceFromEdge}px;
    right: ${alertWindowDistanceFromEdge}px;
    border-radius: ${alertBorderRadius};
    box-shadow: none;
    z-index: 100;
`;

export const AlertScreenContentDiv = styled.div`
    display: flex;
    justify-content: center;
`;

export const AlertScreenTitle = styled.label`
    font-weight: 500;
    font-size: 19px;
    line-height: 21px;
    color: #545454;
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 16px;
    margin-bottom: 0;
`;

export const AlertScreenContent = styled.div`
    font-weight: 300;
    font-size: 17px;
    color: #555555;
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 12px;
    margin-bottom: 20px;
    padding: 0;
    text-align: center;
`;

export const AlertScreenButtonsRow = styled.div`
    display: flex
    > div {
        overflow: hidden;
    }
`;

export const AlertScreenButton = styled.div`
    background-color: ${styles.primaryColor};
    height: 48px;
    font-size: 19px;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
`;

const buttonBorderColor = `white`;
const buttonBorderWidth = `1px`;
const buttonBorderStyle = `solid`;

export const AlertScreenButtonSingle = AlertScreenButton.extend`
    border-bottom-left-radius: ${alertBorderRadius};
    border-bottom-right-radius: ${alertBorderRadius};
`;

export const AlertScreenButtonLeft = AlertScreenButton.extend`
    border-bottom-left-radius: ${alertBorderRadius};
    border-right-color: ${buttonBorderColor};
    border-right-width: ${buttonBorderWidth};
    border-right-style: ${buttonBorderStyle};
`;

export const AlertScreenButtonRight = AlertScreenButton.extend`
    border-bottom-right-radius: ${alertBorderRadius};
    border-left-color: ${buttonBorderColor};
    border-left-width: ${buttonBorderWidth};
    border-left-style: ${buttonBorderStyle};
`;



// WEBPACK FOOTER //
// ./src/Components/GreyOverlay/Alert/AlertStyle.js